import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton, AppBar, Toolbar, Divider } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';

import Scrollbar from "perfect-scrollbar-react";
import classNames from "classnames";
import "perfect-scrollbar-react/dist/style.min.css";
import "react-table/react-table.css";
import Select from 'react-select';
import Loader from "other-components/loader/loader";
import Tooltip from 'material-ui/Tooltip';
import { withAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert'; // Import
import printjs from 'print-js';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';


const CustomTbodyComponent = props => (
    <div {...props} className={classNames("rt-tbody", props.className || [])}>
        <Scrollbar>{props.children}</Scrollbar>
    </div>
);


const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    smaller: {
        width: 30,
        height: 20,
    }
});

var data = []
var ohc = []
var abt = []
var tableData = []
var count;
var lastBalance = 0;
var nameArray = []


class ProfitAndSaleReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            fromDate: moment(new Date()).format("YYYY-MM-DD"),
            toDate: moment(new Date()).format("YYYY-MM-DD"),
            tableData: [],
            totalCashDebit: 0,
            totalCashCredit: 0,
            totalCreditDebit: 0,
            totalCreditCredit: 0,
            cashRevenue: 0,
            creditRevenue: 0,
            totalRevenue: 0,
            accountName: ''
        };
    }

    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleViewClick() {
        lastBalance = 0;
        nameArray = [];
        this.cashSalesBalance(this.state.fromDate, this.state.toDate);
        this.creditSalesBalance(this.state.fromDate, this.state.toDate);
        this.loadLedgerDetails()


    };



    setStateData() {
        tableData = [];
        abt = [];
        abt = data.slice()
        // abt.push({
        //     accountName: "Net Profit / Loss from ordinary",
        //     id: null,
        //     credit: '',
        //     debit: ''
        // }, {
        //         accountName: "Activities before taxation",
        //         id: null,
        //         credit: '111110',
        //         debit: ''
        //     })

        this.setState({ tableData: abt })
        // alert(JSON.stringify(abt))
    }


    loadLedgerDetails() {
        var ledgerAccArray = [];
        // axios.post('http://localhost:5009/accountCategory/getAccountCategoryByType', { id: 5 })
        axios.post(window.accountServer + '/accountCategory/getAccountCategoryByType', { id: 5 })
            .then(response => {
                if (response.data.success) {
                    // resObj = response.data.ledgerAccountDetails;
                    if (response.data.accountCategories.length == 0) {
                        this.setState({ ledgerAccArray: [], ledgerAcc: '' });
                    } else {
                        data = []
                        data.push({
                            accountName: "Over Head Cost",
                            id: null,
                            credit: '',
                            debit: ''
                        })

                        for (let i = 0; i < response.data.accountCategories.length; i++) {
                            const categoryObj = {
                                name: response.data.accountCategories[i].NAME,
                                id: response.data.accountCategories[i].ID_ACCOUNT_CATEGORY
                            }
                            // alert("a")
                            // axios.post('http://localhost:5009/ledgerAccount/getLedgerAccountListByCategoryId', categoryObj)
                            axios.post(window.accountServer + '/ledgerAccount/getLedgerAccountListByCategoryId', categoryObj)
                                .then(response => {
                                    if (response.data.success) {

                                        if (response.data.ledgerData.length > 0) {
                                            count = response.data.ledgerData.length;
                                            // alert("b"+count)
                                            for (let i = 0; i < response.data.ledgerData.length; i++) {

                                                // nameArray.push({
                                                //     id: response.data.ledgerData[i].ID_LEDGER_ACCOUNT
                                                // })
                                                const ledgerObj = {
                                                    ledger_name: response.data.name,
                                                    ledger_id: response.data.ledgerData[i].ID_LEDGER_ACCOUNT,
                                                    fromDate: this.state.fromDate,
                                                    toDate: this.state.toDate
                                                }
                                                // axios.post('http://localhost:5009/transactionLedger/getLedgerreportData', ledgerObj)
                                                axios.post(window.accountServer + '/transactionLedger/getLedgerreportData', ledgerObj)
                                                    .then(response => {
                                                        if (response.data.success) {
                                                            var resObj = response.data.ledgerReport;
                                                            if (response.data.ledgerReport.length > 0) {
                                                                this.expencesBalance(response.data.ledgerName, resObj)
                                                            }
                                                        }

                                                    })
                                                    .catch(error => {
                                                        // logger.error(error);
                                                    });
                                            }

                                            // alert(JSON.stringify(nameArray))
                                        }
                                    }
                                }).catch(error => {
                                    // logger.error(error);
                                });
                        }
                    }
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    expencesBalance(name, resObj) {
        // alert("cc" + count)
        count = count - 1
        var totalCredit = 0;
        var totalDebit = 0;

        // if (resObj.length > 0) {
        // alert("d" + name)
        for (var i = 0; i < resObj.length; i++) {

            totalCredit = totalCredit + parseFloat(resObj[i].DR)
            totalDebit = totalDebit + parseFloat(resObj[i].CR)
        }
        var balance = totalCredit - totalDebit
        lastBalance = lastBalance + balance
        // alert(lastBalance)


        // if (count == 0) {
        // alert("c2c" + count)
        // this.setStateData()
        // alert(name)
        data = data.slice()
        data.push({
            // update_id: billObj[i].ID_BILL_ENTRIES,
            accountName: name,
            id: '',
            credit: '',
            debit: lastBalance
        });
        this.setStateData()
        lastBalance = 0;
        // }
        // }



    }

    cashSalesBalance(fromDate, toDate) {
        var totalCashDebit = this.state.totalCashDebit;
        var totalCashCredit = this.state.totalCashCredit;
        const ledgerObj = {
            ledger_id: 1,
            fromDate: fromDate,
            toDate: toDate
        }

        // var ledger_id = this.state.ledgerType.value;
        // var fromDate = this.state.startDate;
        // var toDate = this.state.endDate;

        var strtDt = new Date(fromDate);
        var endDt = new Date(toDate);


        if (fromDate != null && fromDate != "") {
            if (toDate != null && toDate != "") {
                if (endDt.getTime() < strtDt.getTime()) {
                    this.props.alert.error("to date Can't be less than from date");
                } else {
                    // this.setState({ loading: true });
                    // axios.post('http://localhost:5009/transactionLedger/getLedgerreportData',ledgerObj )
                    axios.post(window.accountServer + '/transactionLedger/getLedgerreportData', ledgerObj)
                        .then(response => {
                            var resObj = response.data.ledgerReport;

                            for (var i = 0; i < resObj.length; i++) {

                                totalCashDebit = totalCashDebit + parseFloat(resObj[i].DR)
                                totalCashCredit = totalCashCredit + parseFloat(resObj[i].CR)
                            }
                            var cashRevenue = totalCashCredit - totalCashDebit;
                            this.setState({
                                cashRevenue: cashRevenue
                            })

                        }
                        )
                        .catch(error => {
                            // logger.error(error);
                        });
                }

            } else {
                this.props.alert.error("Select To Date");
            }
        } else {
            this.props.alert.error("Select From Date.");
        }
    }

    creditSalesBalance(fromDate, toDate) {
        var totalCreditDebit = this.state.totalCreditDebit;
        var totalCreditCredit = this.state.totalCreditCredit;
        const ledgerObj = {
            ledger_id: 2,
            fromDate: fromDate,
            toDate: toDate
        }

        // var ledger_id = 2;
        // var fromDate = this.state.startDate;
        // var toDate = this.state.endDate;

        var strtDt = new Date(fromDate);
        var endDt = new Date(toDate);


        if (fromDate != null && fromDate != "") {
            if (toDate != null && toDate != "") {
                if (endDt.getTime() < strtDt.getTime()) {
                    this.props.alert.error("to date Can't be less than from date");
                } else {
                    // this.setState({ loading: true });
                    // axios.post('http://localhost:5009/transactionLedger/getLedgerreportData',ledgerObj )
                    axios.post(window.accountServer + '/transactionLedger/getLedgerreportData', ledgerObj)
                        .then(response => {
                            var resObj = response.data.ledgerReport;

                            for (var i = 0; i < resObj.length; i++) {

                                totalCreditDebit = totalCreditDebit + parseFloat(resObj[i].DR)
                                totalCreditCredit = totalCreditCredit + parseFloat(resObj[i].CR)
                            }
                            var creditRevenue = totalCreditCredit - totalCreditDebit


                            var totalRevenue = this.state.cashRevenue + creditRevenue
                            this.setState({
                                totalRevenue: totalRevenue
                            })
                            console.log("TcashRevenue " + this.state.cashRevenue)
                            console.log("TcreditRevenue" + creditRevenue)
                            console.log("totalRevenue" + totalRevenue)
                        }
                        )
                        .catch(error => {
                            // logger.error(error);
                        });
                }

            } else {
                this.props.alert.error("Select To Date");
            }
        } else {
            this.props.alert.error("Select From Date.");
        }
    }

    handlePrintClick() {
        if (!this.state.fromDate || !this.state.toDate
            || this.state.fromDate == '' || this.state.toDate == '') {
            return this.props.alert.error('Select Date Range');
        }

        var path = null;
        // axios.post(window.reportServer+'/journalReport/getJournalReport', 
        // {
        //     fromDate : this.state.fromDate,
        //     toDate : this.state.toDate
        // }
        // )
        // .then(response => {
        //     path = response.data.path;
        //     path = window.reportServer+"/" + path;
        //     const url = path;
        //     window.open(url, '_blank');
        // }
        // );
    }

    render() {
        if (this.state.loading) {
            return (
                <Loader />
            );
        } else {
            return (
                <div>
                    <div className="p-8">
                        <h2 className="subtitle-color invoice-margin">Profit And Loss (Reporting)</h2>
                    </div>

                    <div className="p-8">
                        <TextField
                            id="name"
                            className="inline-block w-1/5 -mt-8"
                            //className={classes.textField}
                            /* classes={{
                                input: classes.input
                            }} */
                            label="From Date"
                            placeholder=""
                            type="date"
                            value={this.state.fromDate}
                            onChange={this.handleTextBoxChange('fromDate')}
                        />
                        <TextField
                            id="name"
                            className="inline-block w-1/5 -mt-8"
                            //className={classes.textField}
                            /* classes={{
                                input: classes.input
                            }} */
                            label="To Date"
                            placeholder=""
                            type="date"
                            value={this.state.toDate}
                            onChange={this.handleTextBoxChange('toDate')}
                        />

                    </div>

                    <DialogActions className="justify-right pl-16">
                        <Button
                            variant="raised"
                            color="secondary"
                            className="px-40 mx-16"
                            onClick={
                                (ev) => {
                                    ev.stopPropagation();
                                    this.handleViewClick();
                                }
                            }
                        >
                            View
                    </Button>
                        <Button
                            variant="raised"
                            color="secondary"
                            className="px-40 mx-16"
                            onClick={
                                (ev) => {
                                    ev.stopPropagation();
                                    this.handlePrintClick();
                                }
                            }
                        >
                            Print
                    </Button>
                    </DialogActions>
                    <Divider />

                    <div className="flex flex-wrap -mx-3 mb-6">

                        <div className="w-full profilt-company-margin  inline-block "> </div>

                        <div className="w-full sm:w-1/5  md:w-1/5  inline-block">
                            <label><strong>Industrial Calibration & Services Center (Pvt) Ltd</strong></label>

                        </div>

                    </div>

                    <div className="flex flex-wrap -mx-4 mb-6">

                        <div className="w-full profilt-company-margin inline-block"> </div>

                        <div className="w-full sm:w-1/5 md:w-1/5 inline-block">
                            <label><strong>Date Range : </strong> {this.state.fromDate + " - " + this.state.toDate}</label>
                        </div>

                    </div>
                    <div className="p-8">
                        <h4>Revenue</h4>
                        <TextField
                            id="name"
                            className="inline-block w-1/5 -mt-8"
                            disabled={true}
                            value={this.state.totalRevenue}
                        // className={classes.textField}
                        // classes={{
                        //     input: classes.input
                        // }}

                        />
                    </div>
                    <ReactTable
                        data={this.state.tableData}
                        columns={[

                            {
                                Header: "",
                                accessor: "accountName"
                            },
                            {
                                Header: "",
                                accessor: "debit",
                                width: 300
                            },
                            {
                                Header: "",
                                accessor: "credit",
                                width: 300
                            }
                        ]}
                        pageSize={10}
                        //defaultPageSize={10}
                        className="-striped -highlight"
                    />
                </div>
            )
        }

    }

    componentWillMount() {

    }

}

export default withStyles(styles, { withTheme: true })(withAlert(ProfitAndSaleReport));










// WEBPACK FOOTER //
// ./src/main/content/accountingReports/profitAndSaleReport/ProfitAndSaleReport.js